export const budgetRange = [
  '50.000€ to 75.000€',
  '75.000€ to 150.000€',
  '150.000€ to 250.000€',
  '250.000€ to 500.000€',
  '500.000€ to 1.000.000€',
  '1.000.000€ and above'
];
